import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import Service from '@/service/index.js';
import 'swiper/dist/css/swiper.css';
import HomeService from '../service.js';
import BidprojectService from '../../bid-project/bid-project-service.js';

export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      hoverIndex: -1,
      projectType: [],
      purchaseProjectType: [],
      projectTypeList: [{name: '交易公告'}, {name: '采购公告'}],
      activeItem: 2,
      projectList: [],
      transferProject: {activeIndex: 1},
      // swiperOption: {
      //   loop: false,
      //   slidesPerView: 9
      // },
      tableList: [],
      searchForm: {
        pageNum: 1,
        pageSize: 20
      },
      bidStatusArr: [
        {code: '1', value: '未开始'},
        {code: '60', value: '竞价中'},
        {code: '3', value: '已结束'}
      ],
      bidModeArr: null,
      swiperOption: {
        autoplay: {
          delay: 500
        },
        loop: true,
        direction: 'vertical',
        slidesPerView: 10
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    this.getDictionarySelect();
    this.funGetbid();
  },
  methods: {
    // 获取竞价列表
    funGetbid() {
      HomeService.getBidAlllist(this.searchForm).then(res => {
        if (res.code === '0') {
          const arr = res.data && res.data.list;
          arr.forEach(item => {
            if(item.status === '60') {
              item.color = '#12FF00';
            } else if(item.status === '1') {
              item.color = '#FFAB10';
            } else {
              item.color = '#FA5741';
            }
          });
          this.tableList = [...arr];
          // console.log(this.tableList,'3213123');
        }
      });
    },

    // 更多跳转详情
    goBidDetail() {
      this.$router.push('/bid-project');
    },
    goToSignUpDetail (obj) {
      BidprojectService.getEjyToken(obj.bidId).then(res => {
        if (res && res.code === '0' && res.data) {
          window.open(res.data);
          console.log(res.data, 'res.data.token');
        }
      }).catch((res) => {
        if(res.data.code !== '999') {
          this.$confirm('您还没报名该项目，请先报名后再竞价', '提示', {
            confirmButtonText: '立即报名',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.submit();
            if(Number(obj.type) === 1) {
              this.$router.push('/transaction-pro/detail?id=' + obj.projectId);
            } else {
              this.$router.push('/collective-purchasing/detail?id=' + obj.projectId);
            }
          }).catch(() => {
          });
        }
      });
    },
    // 获取字典项
    getDictionarySelect() {
      const arr = [
        // ['projectType', 'PROJECT_TYPE'], // 项目类型-转让项目
        // ['purchaseProjectType', 'PURCHASE_PROJECT_TYPE'], // 项目类型-采购项目
        ['bidModeArr', 'BIDDING_METHOD'] // 竞价方式
      ];
      arr.forEach((value) => {
        if (!value.length) {
          return;
        }
        Service.getSelectList(value[1]).then(res => {
          if (res && res.code === '0') {
            res.data.forEach(v => { v.code = Number(v.code);});
            this[value[0]] = res.data;
            this[value[0]].forEach(v => {
              if (value[0] === 'purchaseProjectType') {
                v.img1 = require(`@/assets/images/home/project/purchase-${v.code}_1.png`);
                v.img2 = require(`@/assets/images/home/project/purchase-${v.code}_2.png`);
              } else {
                v.img1 = require(`@/assets/images/home/project/${v.code}_1.png`);
                v.img2 = require(`@/assets/images/home/project/${v.code}_2.png`);
              }
            });
            if ( this.activeItem === 1) {
              this.projectList = this.projectType;
            } else {
              this.projectList = this.purchaseProjectType;
            }
          }
        });
      });
    },
    swiperEnter() {
      this.swiper.autoplay.stop();
    },
    swiperLeave() {
      this.swiper.autoplay.start();
    }
    // 选择项目分类
    // chooseType(index) {
    //   this.activeItem = index;
    //   this.transferProject.activeIndex = 1;
    //   this.searchForm.projectType = 1;
    //   if (this.activeItem === 1) {
    //     this.projectList = this.projectType;
    //   } else {
    //     this.projectList = this.purchaseProjectType;
    //   }
    //   this.getProjectList();
    // },
    // chooseProject(index) {
    //   this.transferProject.activeIndex = index;
    //   this.searchForm.projectType = this.transferProject.activeIndex;
    //   this.getProjectList();
    // },
    // tableRowClassName({row}) {
    //   if (row.state === 1) {
    //     return 'table_cell_1';
    //   } else if (row.state === 2) {
    //     return 'table_cell_2';
    //   } else if (row.state === 3) {
    //     return 'table_cell_3';
    //   }
    //   return '';
    // },
    // hoverItem(index) {
    //   this.hoverIndex = index;
    // }
  }
};
